import * as React from "react";
import Input from "../../Input-new/Input";
import Textarea from "../../Textarea-new/Textarea";


const Proposal = ({ data, edit, addNewItem, handleChangeInput, viewMode, deleted, proposalSelected,
}) => {
    return (
        <div className="Notes-info">
            <div className="Notes-info_column Notes-info-box Website_column_item">
                <Textarea
                    name="strengths"
                    label="Strengths"
                    value={data.strengths}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}
                />
            </div>
            <div className="Notes-info_column Notes-info-box">
                <Textarea
                    name="challenges"
                    label="Challenges"
                    value={data.challenges}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}

                />
            </div>
            <div className="Notes-info_column Notes-info-box">
                <Textarea
                    name="buyer_pool"
                    label="Buyer Pool"
                    maxWidth="100%"
                    value={data.buyer_pool}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}

                />
            </div>
            <div className="Notes-info_column Notes-info-box">
                <Textarea
                    name="qualifications"
                    label="QUALIFICATIONS"
                    maxWidth="100%"
                    value={data.qualifications}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}

                />
            </div>
            <div className="Notes-info_column Notes-info-box">
                <Textarea
                    name="recommendations"
                    label="RECOMMENDATIONS"
                    maxWidth="100%"
                    value={data.recommendations}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isList={true}

                />
            </div>

        </div>
    )
};

export default Proposal;
